import React from "react";
import jetblackBg from "../assets/images/jetblack-bg.png";

const MobileVIPAssistance = () => {
  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Thank you! Your VIP assistance request has been sent.");
  };

  return (
    <div className="vip-wrapper">
      {/* Contenedor de la imagen (lado izquierdo) */}
      <div className="image-container">
        <img
          src={jetblackBg}
          alt="Jet Black Background"
          className="jetblack-bg"
        />
      </div>

      {/* Contenedor del contenido (lado derecho) */}
      <div className="vip-container">
        {/* Contenedor del mapa */}
        <div className="map-container">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d11924.23739004644!2d-73.7414121!3d41.4763134!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c2b7a158aac975%3A0x1c4c799c94732753!2sJet%20Black%20Limousine!5e0!3m2!1sen!2sus!4v1673452458886!5m2!1sen!2sus"
            className="map"
            title="Location"
            allowFullScreen=""
            loading="lazy"
          ></iframe>
        </div>

        {/* Formulario para solicitar asistencia VIP */}
        <form className="vip-form" onSubmit={handleSubmit}>
          <h3 className="form-title">Request VIP Assistance</h3>
          <input type="text" placeholder="Name" className="input" required />
          <input type="email" placeholder="Email" className="input" required />
          <input type="text" placeholder="Phone" className="input" required />
          <textarea
            placeholder="Your Message"
            className="textarea"
            required
          ></textarea>
          <button type="submit" className="button">
            Send Request
          </button>
        </form>
      </div>

      {/* Estilos inyectados */}
      <style>
        {`
          /* Contenedor principal con dos columnas */
          .vip-wrapper {
            display: flex;
            flex-direction: row;
            width: 100%;
            min-height: 100vh;
          }

          /* Contenedor de la imagen (lado izquierdo) */
          .image-container {
            flex: 1;
            overflow: hidden;
          }

          .jetblack-bg {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }

          /* Contenedor del contenido (lado derecho) */
          .vip-container {
            flex: 1;
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 20px;
            background-color: #f8f8f8;
            font-family: Arial, sans-serif;
          }

          .map-container {
            width: 100%;
            max-width: 600px;
            margin-bottom: 20px;
            border-radius: 8px;
            overflow: hidden;
            box-shadow: 0 4px 8px rgba(0,0,0,0.1);
          }

          .map {
            width: 100%;
            height: 300px;
            border: none;
          }

          .vip-form {
            width: 100%;
            max-width: 600px;
            background-color: #fff;
            padding: 20px;
            border-radius: 8px;
            box-shadow: 0 4px 8px rgba(0,0,0,0.1);
            display: flex;
            flex-direction: column;
            gap: 15px;
          }

          .form-title {
            font-size: 1.8rem;
            font-weight: bold;
            margin-bottom: 10px;
            color: #0d2b3e;
            text-align: center;
          }

          .input, .textarea {
            width: 100%;
            padding: 10px;
            font-size: 1rem;
            border: 2px solid #ccc;
            border-radius: 4px;
          }

          .textarea {
            resize: vertical;
            height: 100px;
          }

          .button {
            padding: 12px;
            background-color: #0d2b3e;
            color: #fff;
            border: none;
            border-radius: 4px;
            font-size: 1.2rem;
            font-weight: bold;
            cursor: pointer;
            transition: background-color 0.3s ease;
          }

          .button:hover {
            background-color: #09202e;
          }

          /* Ajustes para dispositivos móviles */
          @media (max-width: 768px) {
            .vip-wrapper {
              flex-direction: column;
            }
            .map {
              height: 250px;
            }
            .form-title {
              font-size: 1.5rem;
            }
            .input, .textarea {
              font-size: 0.9rem;
            }
            .button {
              font-size: 1rem;
            }
          }
        `}
      </style>
    </div>
  );
};

export default MobileVIPAssistance;
